module.exports = __webpack_public_path__ + "img/keyboard_voice.224f00ac.svg";